import * as actions from "./actions/modalActions";

export default { actions };